module.exports = "/images/Icon-3.svg?feb27237c6d99484781c0db0df8d1f35";